import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';

require('react-datetime/css/react-datetime.css');

class ContactItemForm extends React.Component {
  renderField = ({
    input,
    label,
    type,
    disabled,
    readOnly,
    maxLength,
    meta: { touched, error, warning },
  }) => (
    <div className={`${error ? 'has-error' : ''}`}>
      <input
        {...input}
        className="form-control"
        placeholder={label}
        type={type}
        disabled={disabled}
        readOnly={readOnly}
        maxLength={maxLength}
      />
      {touched &&
        ((error && <small className="help-block">{error}</small>) ||
          (warning && <small className="help-block">{warning}</small>))}
    </div>
  );

  onUserChange = val => {
    this.props.change('user', val);
  };

  render() {
    const { handleSubmit, pristine, submitting } = this.props;
    return (
      <div
        className="form-group well"
        onSubmit={handleSubmit}
        style={{ marginBottom: 20 }}
      >
        <label className="col-md-2 control-label">New Contact</label>
        <div className="col-md-3">
          <Field
            className="form-control"
            name="type"
            component={this.renderField}
            type="text"
            label="Type"
          />
        </div>
        <div className="col-md-3">
          <Field
            className="form-control"
            name="contact"
            component={this.renderField}
            type="text"
            label="Contact"
          />
        </div>
        <div className="col-md-3">
          <Field
            className="form-control"
            name="description"
            component={this.renderField}
            type="text"
            label="Description"
          />
        </div>
        <div className="col-md-1">
          <button
            type="submit"
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={pristine || submitting}
          >
            Add
          </button>
          {` `}
        </div>
      </div>
    );
  }
}
const validate = values => {
  const errors = {};
  const required = ['type', 'contact', 'description'];

  required.forEach(el => {
    if (!values[el]) {
      errors[el] = 'Required';
    }
  });

  return errors;
};

ContactItemForm = connect(state => ({
  enableReinitialize: true,
  validate: validate,
}))(reduxForm({ form: 'contactItemForm' })(ContactItemForm));
export default ContactItemForm;



// WEBPACK FOOTER //
// ./src/routes/administration/components/location/ContactItemForm.js